"use client";

import { Trash2 } from "lucide-react";

import { useStyles } from "./styles";
import { AlertDialogType } from "@/types/alert";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { addAlertDialog } from "@/redux/actions";

interface DeleteGenerationProps {
  id: number;
}

const DeleteGeneration: React.FC<DeleteGenerationProps> = ({ id }) => {
  const { classes, cx } = useStyles();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.user);
  const isSubscribed = Boolean(user && user?.subscriptionType !== "free");

  const handleDelete = () => {
    if (!isSubscribed) {
      dispatch(
        addAlertDialog({
          title: "Subscription Required",
          description: "You need a premium subscription to delete ideas!",
          nextButtonText: "Upgrade",
          type: AlertDialogType.SubscriptionRequired,
        })
      );
      return;
    }

    dispatch(
      addAlertDialog({
        title: "Delete idea",
        description:
          "Are you sure you want to delete this? This action cannot be undone.",
        nextButtonText: "Confirm Delete",
        type: AlertDialogType.DeleteGeneration,
        data: { generationId: id },
      })
    );
  };

  return (
    <button
      className={cx(classes.deleteButton, !isSubscribed && classes.disabled)}
      onClick={handleDelete}
      aria-label="Delete Generation"
    >
      <Trash2 size={16} />
    </button>
  );
};

export default DeleteGeneration;
